import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.75011 20C7.75011 21.3807 8.8694 22.5 10.2501 22.5C11.6308 22.5 12.7501 21.3807 12.7501 20V16H14.7094C15.2406 16 15.7622 15.859 16.221 15.5913L20.3506 13.1824C21.5771 12.4669 22.134 10.9895 21.685 9.64242L19.6546 3.55132C19.2463 2.32629 18.0999 1.5 16.8086 1.5H8.73492C7.80351 1.5 6.92493 1.93261 6.35705 2.67087L1.52051 8.95837L2.54659 10.4975C2.99614 11.1718 3.80821 11.5082 4.60292 11.3492L7.75011 10.7198V20Z"}}]};

const GestureDownFilled = Vue.extend<IconProps>({
  name: 'GestureDownFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gesture-down-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GestureDownFilled;
